import { render, staticRenderFns } from "./kargoGenel.vue?vue&type=template&id=e21e0fee"
import script from "./kargoGenel.vue?vue&type=script&lang=js"
export * from "./kargoGenel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports